













































import BaseComponent from '@/components/base-component.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import { parseStringToDate } from '@/helpers/dateUtils';
import moment from 'moment';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    UiDatePicker
  }
})
export default class AdvanceProductionDialog extends BaseComponent {
  @Prop()
  permissions: any;

  showDialog: boolean = false;
  justification: string = null;
  advanceDelivery: boolean = null;
  newDeliveryDate: string = null;
  minDate = null;
  maxDate = null;

  public $refs!: {
    form: HTMLFormElement;
  };

  public form: any = {
    valid: false,
    rules: {
      justification: [(v) => !!v || 'Informe a justificativa'],
      advanceDelivery: [(v) => v != null || 'Informação obrigatória'],
      newDeliveryDate: [(v) => this.validarData(v)]
    }
  };

  mounted() {
    this.showDialog = true;
    setTimeout(() => {
      this.$refs['justification'].focus();
    }, 500);
  }

  onOkClick() {
    this.$refs.form.validate();
    if (!this.form.valid) {
      return;
    }
    if (!this.advanceDelivery) {
      this.newDeliveryDate = null;
    }
    this.$emit('confirm', this.justification, this.newDeliveryDate);
  }

  onCancelClick() {
    this.$emit('cancel');
  }

  @Watch('permissions', { immediate: true })
  onPermissionsChange() {
    if (!this.permissions) {
      this.minDate = null;
      this.maxDate = null;
      return;
    }
    this.minDate = this.permissions.adiantDataEntregaMin;
    this.maxDate = this.permissions.adiantDataEntregaMax;
    if (moment(this.maxDate, 'YYYY/MM/DD').isSameOrBefore(moment(new Date()))) {
      this.newDeliveryDate = this.permissions.adiantDataEntregaMax;
    }
  }

  validarData(v): boolean | string {
    if (v == null || v == '') {
      return 'Informe uma data válida';
    }

    if (!moment(v, 'DD/MM/YYYY').isValid()) {
      return 'Informe uma data válida';
    }

    if (moment(v, 'DD/MM/YYYY').isBefore(parseStringToDate(this.permissions.adiantDataEntregaMin))) {
      return 'A data deve ser maior ou igual a ' + this.dateFormatHelper(this.permissions.adiantDataEntregaMin, 'BR');
    }

    if (moment(v, 'DD/MM/YYYY').isAfter(parseStringToDate(this.permissions.adiantDataEntregaMax))) {
      return 'A data deve ser menor ou igual a ' + this.dateFormatHelper(this.permissions.adiantDataEntregaMax, 'BR');
    }

    return true;
  }
}
